import { render, staticRenderFns } from "./TsBranchFilter.vue?vue&type=template&id=856e804e&scoped=true&"
import script from "./TsBranchFilter.vue?vue&type=script&lang=js&"
export * from "./TsBranchFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsBranchFilter.vue?vue&type=style&index=0&id=856e804e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856e804e",
  null
  
)

export default component.exports